// extracted by mini-css-extract-plugin
export default {"cargando":"MensajeCargando_cargando__yNgGx","spinner":"MensajeCargando_spinner__7xZ2F","spin":"MensajeCargando_spin__f1oVP"};